module.exports = __webpack_public_path__ + "static/media/Artboard_white.fa314e4d.png";